import { Card, CardContent } from "@/components/ui/card";
import { GoogleMapPreview } from "@/components/properties/GoogleMapPreview";
import { BlurredMapOverlay } from "./BlurredMapOverlay";
import { Link as LinkIcon, MapPin } from "lucide-react";

interface PropertyMapCardProps {
  address: string;
  city: string;
  state: string;
  zipCode: string;
  zillowLink: string | null;
  isAuthenticated?: boolean;
}

export const PropertyMapCard = ({
  address,
  city,
  state,
  zipCode,
  zillowLink,
  isAuthenticated = true
}: PropertyMapCardProps) => {
  // Show blurred overlay for unauthenticated users
  if (!isAuthenticated) {
    return (
      <BlurredMapOverlay
        address={address}
        city={city}
        state={state}
        zipCode={zipCode}
      />
    );
  }

  // Show full map and Zillow link for authenticated users
  const streetViewUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address + ', ' + city + ', ' + state + ' ' + zipCode)}`;

  return (
    <Card>
      <CardContent className="p-0">
        <div className="w-full">
          <GoogleMapPreview
            address={address}
            city={city}
            state={state}
            zipCode={zipCode}
          />
        </div>
        <div className="p-4 flex flex-col gap-2">
          <a
            href={zillowLink || `https://www.zillow.com/homes/${encodeURIComponent(address + ' ' + city + ' ' + state)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-godyspo-blue hover:underline text-sm"
          >
            <LinkIcon className="h-4 w-4 mr-1" />
            View on Zillow
          </a>
          <a
            href={streetViewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-godyspo-blue hover:underline text-sm"
          >
            <MapPin className="h-4 w-4 mr-1" />
            View on Google Maps
          </a>
        </div>
      </CardContent>
    </Card>
  );
};
